/* Copyright 2013 - 2024 Waiterio LLC */
/* eslint-disable no-useless-escape */

export default function slugify(text) {
  return text
    .replace(/([^\w]+|\s+)/g, '-')
    .replace(/\-\-+/g, '-')
    .toLowerCase()
}
